import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";

/**
 * Left-edge vertical scroll progress bar.
 * Fills from top to bottom as user scrolls.
 * Mobile: thinner, still fully visible.
 */
export default function ScrollProgressBar() {
  const [progress, setProgress] = useState(0);
  const { pathname } = useLocation();

  const updateProgress = useCallback(() => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const pct = docHeight > 0 ? Math.round((scrollTop / docHeight) * 100) : 0;
    setProgress(pct);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", updateProgress, { passive: true });
    updateProgress();
    return () => window.removeEventListener("scroll", updateProgress);
  }, [updateProgress, pathname]);

  // Don't show on admin pages
  if (pathname.startsWith("/admin")) return null;

  return (
    <div
      aria-hidden="true"
      data-testid="scroll-progress-bar"
      className="fixed left-0 top-0 z-[45] w-1 sm:w-1.5 h-full pointer-events-none"
      style={{ background: "rgba(0,0,0,0.06)" }}
    >
      {/* Progress fill */}
      <div
        className="absolute top-0 left-0 w-full transition-[height] duration-100 ease-linear"
        style={{
          height: `${progress}%`,
          background: "linear-gradient(to bottom, #EE4F7A 0%, #C026D3 50%, #7CEDD9 100%)",
        }}
      />
      {/* Indicator dot */}
      {progress > 0 && progress < 100 && (
        <div
          className="absolute left-1/2 -translate-x-1/2 h-3 w-3 rounded-full shadow-md border-2 border-white"
          style={{
            top: `calc(${progress}% - 6px)`,
            background: "linear-gradient(135deg, #EE4F7A, #C026D3)",
            transition: "top 100ms linear",
          }}
        />
      )}
    </div>
  );
}
